import Repository from "./Repository";
import { TrainingTopic } from "../types/TrainingTopic";

const resource = "/trainingTopic";

export default {
  save(training: TrainingTopic) {
    if (training.trainingTopicId) {
      return Repository.patch(
        `${resource}/${training.trainingTopicId}`,
        training
      );
    } else {
      return Repository.post(`${resource}`, training);
    }
  },
  delete(trainingTopicId: string) {
    return Repository.delete(`${resource}/${trainingTopicId}`);
  }
};
